import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import { hydrateRoot } from 'react-dom/client';

import { loadableReady } from '@loadable/component';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import RootWebView from '@RootWebView'; // This path is changed during the compilation

import { getClientModifiers } from '../shared/getClientModifiers';

import { FeatureFlagsProvider } from './FeatureFlagsProvider';
import { FragmentContextProvider } from './FragmentContext';
import { getFragmentStateValue } from './fragmentState';

const getFragmentsComponent = (state) => {
  const { fragmentContextData, rootWebViewProps, featureFlags, isFragment } = state;
  const { enhanceApp, modifyClientRouterParams } = getClientModifiers();

  const browserProps = modifyClientRouterParams({ isFragment });

  const EnhancedApp = enhanceApp({ DefaultApp: RootWebView, state });

  return (
    <BrowserRouter {...browserProps}>
      <FragmentContextProvider data={fragmentContextData}>
        <FeatureFlagsProvider featureFlags={featureFlags}>
          <EnhancedApp {...rootWebViewProps} />
        </FeatureFlagsProvider>
      </FragmentContextProvider>
    </BrowserRouter>
  );
};

function render(state: ReturnType<typeof getFragmentStateValue>) {
  const { rootElementId } = state;
  const { replaceAppComponent } = getClientModifiers();
  const fragmentComponent = replaceAppComponent({ state }) || getFragmentsComponent(state);

  const root = document.getElementById(rootElementId);
  hydrateRoot(root, fragmentComponent);
}

const fragmentState = getFragmentStateValue();
if (fragmentState && !fragmentState.hydrated && WEBPACK_APP_IDENTIFIER === fragmentState.appIdentifier) {
  fragmentState.hydrated = true;
  loadableReady(() => render(fragmentState), {
    namespace: `${fragmentState.appIdentifier}-${fragmentState.fragmentType}`,
  });
}
